var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Layout, Dependencies } from "~/core/decorator";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import DataForm from "~/components/common/data-form.vue";
import DataBox from "~/components/common/data-box.vue";
import { Emit } from "vue-property-decorator";
import { State } from "vuex-class";
import ImportDivisionCase from "~/components/case-manage/case-division-import/import-division-case.vue";
import { UploadFileService } from "~/services/common-service/upload-file.service";
import { DataImportService } from "~/services/dataimp-service/data-import.service";
var CaseDivisionImportList = /** @class */ (function (_super) {
    __extends(CaseDivisionImportList, _super);
    function CaseDivisionImportList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.searchModel = {
            batchNumber: "",
            status: "" //导入状态
        };
        _this.dialog = {
            importCase: false
        };
        _this.dataSet = [];
        _this.seqNo = "";
        _this.loading = {
            state: false
        };
        return _this;
    }
    CaseDivisionImportList.prototype.mounted = function () {
        var _this = this;
        this.refreshData();
        // 收到消息通知时更新未读消息
        this.$reminder.addImportListener().subscribe(function (data) {
            if (data === "DISTRIBUTE" || data === "DISTRIBUTE_CONFIRM") {
                var self = _this;
                setTimeout(function () {
                    self.refreshData();
                }, 2000);
            }
        });
    };
    CaseDivisionImportList.prototype.refreshData = function () {
        var _this = this;
        this.dataImportService
            .findAllDistributeRecord(this.searchModel, this.pageService, this.sortService, this.loading)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 错误信息下载
     */
    CaseDivisionImportList.prototype.errorTipsDownload = function (row) {
        var _this = this;
        this.uploadFileService
            .getFileStreamById(row.fileId)
            .subscribe(function () { return _this.$message.success("下载成功"); });
    };
    /**
     * 取消导入
     */
    CaseDivisionImportList.prototype.cancelImport = function (row) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u53D6\u6D88\u5BFC\u5165" + row.seqNo + "\u6279\u6B21\u7684\u6848\u4EF6\u5417\uFF1F", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        })
            .then(function () {
            _this.dataImportService
                .cancelImportDistribute(row.id)
                .subscribe(function (data) {
                _this.$message.success("取消导入成功!");
                _this.refreshData();
            });
        })
            .catch(function (ex) { });
    };
    /**
     * 确认导入
     */
    CaseDivisionImportList.prototype.confirmImport = function (row) {
        var _this = this;
        this.$confirm("\u60A8\u786E\u5B9A\u8981\u5BFC\u5165" + row.batchNumber + "\u6279\u6B21\u7684\u6848\u4EF6\u5417\uFF1F", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
        }).then(function () {
            _this.dataImportService.confirmImportDistribute(row.id).subscribe(function (data) {
                _this.$message.success("正在确认请稍后!");
                _this.refreshData();
            });
        });
    };
    /**
     * 查看详情
     */
    CaseDivisionImportList.prototype.viewDetail = function (rowData) { };
    CaseDivisionImportList.prototype.isShowOperate = function (rowData) {
        return rowData.status === "IMPORT_SUCCESSFULLY";
    };
    /**
     * 下载模板
     */
    CaseDivisionImportList.prototype.downloadTemplate = function () {
        var _this = this;
        this.loading.state = true;
        this.dataImportService
            .downloadDistributeTemplate(this.loading)
            .subscribe(function (data) {
            _this.uploadFileService
                .getFileStreamById(data.id)
                .subscribe(function () { return _this.$message.success("下载成功"); });
        });
    };
    __decorate([
        Dependencies(PageService)
    ], CaseDivisionImportList.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], CaseDivisionImportList.prototype, "sortService", void 0);
    __decorate([
        Dependencies(UploadFileService)
    ], CaseDivisionImportList.prototype, "uploadFileService", void 0);
    __decorate([
        Dependencies(DataImportService)
    ], CaseDivisionImportList.prototype, "dataImportService", void 0);
    __decorate([
        State
    ], CaseDivisionImportList.prototype, "principalList", void 0);
    __decorate([
        Emit("onClickCaseDetail")
    ], CaseDivisionImportList.prototype, "viewDetail", null);
    CaseDivisionImportList = __decorate([
        Layout("workspace"),
        Component({
            components: {
                DataForm: DataForm,
                DataBox: DataBox,
                ImportDivisionCase: ImportDivisionCase
            }
        })
    ], CaseDivisionImportList);
    return CaseDivisionImportList;
}(Vue));
export default CaseDivisionImportList;
